module.exports = __webpack_public_path__ + "static/mourad-d89ea516a09c112177deefafc5f5c17b.png";